import { Button, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'
import React, { useEffect, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmationPopUp } from '../../../components/popup/confirmationPopUp';
import '../incentiveSummary/incentiveSummary.css'
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import RenderSvg from '../../../components/renderSvg/RenderSvg';
import { resetIncentiveValue, updateIncentiveValue } from '../../../stateManagement/actions/incentiveActions';

export const DefineIncentivePreview = (props: {setPreviewOpen:React.Dispatch<React.SetStateAction<boolean>>}) => {
    const [data, setData] = useState<any[]>([]);
    const [openDialog, setOpenDialog] = useState(false);
    const storeData = useSelector((state: any) => state?.manageIncentive?.data);


    useEffect(() => {
        const transformedData = [{
            incentiveCalculation: storeData?.calculationType?.value || '',
            incentiveFrequency: storeData?.period?.value || '',
            userSelection: storeData?.user?.value?.map((user: any) => user.name).join('\n') || '',
            kpiSelection: storeData?.user?.value.map(() => storeData?.kpi?.value?.map((kpi: any) => kpi.name).join(', ')).join('\n') || '',

            // For each user, repeat the same points for KPIs, separated by '\n' dynamically
            pointsDefined: storeData?.user?.value.map(() => storeData?.kpi?.value?.map((kpi: any) => kpi.points).join(', ')).join('\n') || '',
            incentiveName: storeData?.incentiveName?.value || ''
        }];

        setData(transformedData);
    }, [storeData]);

    const handleEdit = () => {
        props.setPreviewOpen(false);
    }

    const handleDelete = () => {
        updateIncentiveValue(null ,"calculationType");
        updateIncentiveValue(null ,"period");
        updateIncentiveValue(null ,"user");
        updateIncentiveValue(null ,"kpi");
        updateIncentiveValue(null ,"incentiveName");
        // resetIncentiveValue("period");
        // resetIncentiveValue("user");
        // resetIncentiveValue("kpi");
        // resetIncentiveValue("incentiveName");
        props.setPreviewOpen(false);
        console.log("Delete")
    }

    const column = [
        {
            field: "incentiveCalculation",
            headerName: "Incentive Calculation",
            width: 160, renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px", fontWeight : 500 }}>

                    Incentive{"\n"}Calculation
                </div>
            ) ,sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "incentiveFrequency",
            headerName: "Incentive Frequency",
            width: 170, renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" ,fontWeight : 500}}>

                    Incentive{"\n"}Frequency
                </div>
            ),sortable: false,
            disableColumnMenu: true,
        }, {
            field: 'userSelection',
            headerName: 'User Selection',
            width: 180,
            renderCell: (params: any) => (
                <div
                    style={{
                        whiteSpace: 'pre-line',    // Keep multiline formatting
                        maxHeight: '60px',         // Set max height for the cell content
                        overflowY: 'auto',         // Enable vertical scrolling
                        padding: '5px',            // Optional: Add some padding for better aesthetics
                    }}
                >{params.value}</div> // Allow multiline display
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" ,fontWeight : 500}}>

                    User{"\n"}Selection
                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'kpiSelection',
            headerName: 'KPI Selection',
            width: 370,
            renderCell: (params: any) => (
                <div
                    style={{
                        whiteSpace: 'pre-line',    // Keep multiline formatting
                        maxHeight: '60px',         // Set max height for the cell content
                        overflowY: 'auto',         // Enable vertical scrolling
                        padding: '5px',            // Optional: Add some padding for better aesthetics
                    }}
                >
                    {params.value}
                </div>
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" ,fontWeight : 500}}>

                    KPI{"\n"}Selection
                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'pointsDefined',
            headerName: 'Points Defined',
            width: 170,
            renderCell: (params: any) => (
                <div
                    style={{
                        whiteSpace: 'pre-line',    // Keep multiline formatting
                        maxHeight: '60px',         // Set max height for the cell content
                        overflowY: 'auto',         // Enable vertical scrolling
                        padding: '5px',            // Optional: Add some padding for better aesthetics
                    }}
                >{params.value}</div> // Multiline for points
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" ,fontWeight : 500}}>

                    Points{"\n"}Defined
                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'incentiveName',
            headerName: 'Incentive Name',
            width: 180,
            renderCell: (params: any) => (
                <div
                    style={{
                        whiteSpace: 'pre-line',    // Keep multiline formatting
                        maxHeight: '60px',         // Set max height for the cell content
                        overflowY: 'auto',         // Enable vertical scrolling
                        padding: '5px',            // Optional: Add some padding for better aesthetics
                    }}
                >{params.value}</div> // Multiline for points
            ), renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-line', lineHeight: "18px" ,fontWeight : 500}}>

                    Incentive{"\n"}Name
                </div>
            ),sortable: false,
            disableColumnMenu: true,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 80,
            renderCell: (params: any) => (
                <div style={{ display: "flex" }}>
                    <Button style={{ minWidth: "30px" }} onClick={() => handleEdit()}><RenderSvg name="edit_incentive" /></Button>
                    <div >
                        <Button style={{
                            minWidth: "30px",
                            cursor: params.row.isDeleted ? 'not-allowed' : 'pointer', // Disable pointer when disabled
                            opacity: params.row.isDeleted ? 0.5 : 1, // Reduce opacity to indicate disabled state
                        }} onClick={() => { setOpenDialog(true); }}><RenderSvg name="delete_incentive" /></Button>
                    </div>

                </div>

            ),sortable: false,
            disableColumnMenu: true,
        },
    ]
    return (
        <div className="incentiveDataGridContainer" style={{ marginTop: "25px"}}>
            <DataGrid
                disableColumnMenu={true}
                disableColumnFilter={true}

                // Disable individual column sorting
                sortingOrder={[]}  // Remove sorting options globally
                columnVisibilityModel={{
                    checkboxSelection: false  // Disable row selection if used
                }}

                // Remove footer features
                hideFooter={true}  // Removes pagination, "Rows per page", and "x rows selected"
                hideFooterSelectedRowCount={true}  // Removes selected row counter
                disableColumnSelector={true}
                // Disable sorting on all columns
                sx={{
                    paddingInline: '0px',  // Remove padding
                    margin: '0px',         // Remove margin
      
                    // Center the headers and their SVGs
                    '& .MuiDataGrid-columnHeaderTitleContainer': {
                      justifyContent: 'center',
                      alignItems: 'center',
                    },
      
                    // Center the content inside the cells
                    '& .MuiDataGrid-cell': {
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 500, 
                      borderRight: '0.1px solid #E9EFF5',
                      borderBottom: '0.1px solid #E9EFF5' // Thinner grid lines
                    },
      
                    // Center the headers and apply thinner grid lines
                    '& .MuiDataGrid-columnHeaders': {
                      borderRight: '0.1px solid #E9EFF5', // Thinner grid lines
                    },
      
                    // Decrease the width of the grid lines
                    '& .MuiDataGrid-columnHeader': {
                      borderRight: '0.1px solid #E9EFF5', // Thinner grid lines
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 'bold'
                    }
                  }}
                autoHeight
                rowHeight={80}
                className='live_dashboard_table'
                columns={column}
                getRowId={(data: any) => data.incentiveCalculation}
                rows={data} />
            <ConfirmationPopUp
                setOpenConfirmModal={setOpenDialog}
                message="Are you sure you want to delete this incentive?"
                openConfirmModal={openDialog}
                successMethod={async () => {
                    handleDelete()
                }}
            />
        </div>
    )
}